import MatchSearchFilterReasons from 'components/MatchSearchFilterReasons';
import { lastPlayedAgainst, leagueRating, matchmakingRestrictionReasons } from 'functions/matchmaking/matchmakingRestrictions';
import PickSearchesComponent from 'react/matchmaking/PickSearchesComponent';
import { netplayLinkedContinents } from 'react/netplay/netplayPageState';

// Collects the reasons a search is hidden from the viewer on match.failReasons
// (Dashboard.updateSearchBasedOnUserSettings). Distance is never one of them:
// any search can be challenged, however far away.
export default function applySearchFailReasons(match) {
	const user = match.player1;
	if(!user) {
		return;
	}
	if(user.isMe()) {
		return true;
	}
	if(!match.location) {
		console.log(match);
		console.error('match without a location??');
		return;
	}

	match.failReasons.reset();

	if(match.queue_type === PickSearchesComponent.AUTO_QUEUE_ONLY) {
		match.failReasons.addSearchFailReason(MatchSearchFilterReasons.IS_AUTO_QUEUE_ONLY);
	}

	if(!myUser.settings.show_team_searches &&
		match.isDoubles()) {
		match.failReasons.addSearchFailReason(MatchSearchFilterReasons.DOUBLES_SETTING);
	}

	matchmakingRestrictionReasons({
		mySettings: myUser.matchmaking_settings,
		myRating: leagueRating(myUser.ladder_information?.getLeagueForLadder?.(match.ladder.id)),
		theirSettings: match.matchmaking_settings,
		theirRating: leagueRating(user.ladder_information?.getLeagueForLadder?.(match.ladder.id)),
		lastPlayedAt: lastPlayedAgainst(match.recent_opponents, myUser.id),
		now: Math.floor(Date.now() / 1000),
	}).forEach((reasonKey) => match.failReasons.addSearchFailReason(MatchSearchFilterReasons[reasonKey]));

	if(match.gameData.preferred_distance_matters &&
		match.region_restriction) {
		let restriction = match.region_restriction;
		if(restriction.continent_id) {
			if(!netplayLinkedContinents().isLinked(myUser.location.country?.continent_id, restriction.continent_id)) {
				match.failReasons.addSearchFailReason(MatchSearchFilterReasons.CONTINENT_THEIR_SETTING);
			}
		}
		if(restriction.country_id) {
			if(myUser.location.country?.id != restriction.country_id) {
				match.failReasons.addSearchFailReason(MatchSearchFilterReasons.COUNTRY_THEIR_SETTING);
			}
		}
		if(restriction.state_id) {
			if(myUser.location.state?.id != restriction.state_id) {
				match.failReasons.addSearchFailReason(MatchSearchFilterReasons.STATE_THEIR_SETTING);
			}
		}
		if(restriction.locality_id) {
			if(myUser.location.locality?.id != restriction.locality_id) {
				match.failReasons.addSearchFailReason(MatchSearchFilterReasons.LOCALITY_THEIR_SETTING);
			}
		}
	}

	if(!match.gameData.enabled) {
		match.failReasons.addSearchFailReason(MatchSearchFilterReasons.NO_GAME);
	}
}
